import React, { createContext, useContext, useEffect, useState } from 'react'

const AlertsPro = createContext()

export const AlertsState = ({ children }) => {
    const [visible, setVisible] = useState(false)
    const [text, setText] = useState('')
    const [image, setImage] = useState('')
    const [iconLibrary, setIconLibrary] = useState('Feather')
    const [iconSize, setIconSize] = useState(20)
    const [textColor, setTextColor] = useState('white')
    const [backgroundColor, setBackgroundColor] = useState('white')
    const [alertStatic, setAlertStatic] = useState(false)
    const [isLive, setIsLive] = useState(false)
    
    let alertData = {
        text: text,
        image: image,
        iconLibrary: iconLibrary,
        iconSize: iconSize,
        backgroundColor: backgroundColor,
        textColor: textColor,
    }
    
    useEffect(() => {}, [])

    const closeAlert = () => {
        setVisible(false)
        setAlertStatic(false)
        setIsLive(false)
        setBackgroundColor('white')
        setText('')
        setImage('')
        setIconLibrary('Feather')
        setIconSize(20)
        setTextColor('')
    }
    
    const setAlert = (text, textColor, image, backgroundColor, isStatic = false, isLiveUpdate = false, library = 'Feather', size = 20) => {
        // console.log('-----------setAlert-------------')
        setText(text)
        setTextColor(textColor)
        setImage(image)
        setIconLibrary(library)
        setIconSize(size)
        setBackgroundColor(backgroundColor)
        setAlertStatic(isStatic)
        setIsLive(isLiveUpdate)
        setVisible(true)
    }

    const updateAlertText = (newText) => {
        if (visible && isLive) {
            setText(newText)
        }
    }
    
    useEffect(() => {
        if (visible && !alertStatic && !isLive) {
            handleTime()
        }
    }, [visible])

    function handleTime() {
        const timer = setTimeout(() => {
            setVisible(false)
        }, 3000)
        return () => clearTimeout(timer)
    }
    
    const value = {
        visible,
        alertData,
        closeAlert,
        setAlert,
        updateAlertText,
        isLive,
    }
    
    return <AlertsPro.Provider value={value}>{children}</AlertsPro.Provider>
}

export const getAlert = () => {
    return useContext(AlertsPro)
}
